var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1357(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0556641,
    y: 0.592773,
    width: 106,
    height: 71,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5557 51.0927C77.1161 42.5323 77.1161 28.6532 68.5557 20.0927C59.9953 11.5323 46.1161 11.5323 37.5557 20.0927C28.9953 28.6532 28.9953 42.5323 37.5557 51.0927C46.1161 59.6532 59.9953 59.6532 68.5557 51.0927Z",
    fill: "#E60020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7654 47.0998H57.725L53.0386 30.9706L48.3843 47.0998H45.3439L39.333 24.0857H43.0168L47.0276 40.542L51.6498 24.0857H54.4595L59.0817 40.542L63.0925 24.0857H66.7763L60.7654 47.0998Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1357);
export default __webpack_public_path__ + "static/media/1357.565561fb30bd07e8d56e8aa5097cacf9.svg";
export { ForwardRef as ReactComponent };